import React from 'react'
import { FaLyft } from 'react-icons/fa'
import { SiUber } from 'react-icons/si'

const UberLyftIcon = () => {
  return (
    <div
      style={{
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <SiUber style={{ top: '50%', transform: 'translateY(-35%)' }} />
      <FaLyft
        fontSize="0.75em"
        style={{
          position: 'absolute',
          top: '40%',
        }}
      />
    </div>
  )
}

export default UberLyftIcon
